import { render, staticRenderFns } from "./BaseActionSubmit.vue?vue&type=template&id=627058dc&scoped=true&"
import script from "./BaseActionSubmit.vue?vue&type=script&lang=js&"
export * from "./BaseActionSubmit.vue?vue&type=script&lang=js&"
import style0 from "./BaseActionSubmit.vue?vue&type=style&index=0&id=627058dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "627058dc",
  null
  
)

export default component.exports